import { Reveal } from "@/components/site/Reveal";

export const SectionHeader = ({ label, title, desc, align = "left", className = "" }) => (
  <div
    className={`${align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"} ${className}`}
  >
    <Reveal>
      <span className="text-xs font-semibold uppercase tracking-[0.2em] text-teal-400">
        {label}
      </span>
    </Reveal>
    <Reveal delay={1}>
      <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl md:text-5xl">
        {title}
      </h2>
    </Reveal>
    {desc && (
      <Reveal delay={2}>
        <p className="mt-5 text-base leading-relaxed text-white/55 md:text-lg">
          {desc}
        </p>
      </Reveal>
    )}
  </div>
);
